<template>
  <div>
    <h1 class="title">PANTALLA {{ numeroPantalla }} REGULACION PALAS</h1>
    <HmiPantalla>
      <div class="content">
        <div class="screen-title">
          <HmiLabel label="REGULACION PALAS" width="100%" height="100%" :size="4" color="cyan" border="solid 6px yellow">
          </HmiLabel>
        </div>
        <div class="grid">
          <div class="column">
            <div class="custom-row">
              <HmiLabel class="grid-item" label="IMPULSO ABRIR d/seg." width="50%" height="100%" :size="1.7" color="cyan">
              </HmiLabel>
              <HmiLabel class="grid-item" :label="formato2digitos(impulsoAbrir)" width="50%" height="100%" :size="1.7"
                color="#56FF56" :editable="true"
                @input="escrituraDM($event, direccionVariables.IMPULSO_ABRIR_ESCRITURA, 1)"></HmiLabel>
            </div>
            <div class="custom-row">
              <HmiLabel class="grid-item" label="IMPULSO CERRAR d/seg." width="50%" height="100%" :size="1.7"
                color="cyan"></HmiLabel>
              <HmiLabel class="grid-item" :label="formato2digitos(impulsoCerrar)" width="50%" height="100%" :size="1.7"
                color="#56FF56" :editable="true"
                @input="escrituraDM($event, direccionVariables.IMPULSO_CERRAR_ESCRITURA, 1)"></HmiLabel>
            </div>
            <div class="custom-row">
              <HmiLabel class="grid-item" label="ESPERA REGULACION d/seg." width="50%" height="100%" :size="1.7"
                color="cyan"></HmiLabel>
              <HmiLabel class="grid-item" :label="formato3digitos(esperaRegulacion)" width="50%" height="100%" :size="1.7"
                color="#56FF56" :editable="true"
                @input="escrituraDM($event, direccionVariables.ESPERA_REGULACION_ESCRITURA, 1)"></HmiLabel>
            </div>
            <div class="custom-row">
              <HmiButton class="grid-item" label="BOMBA GRASA MANUAL" width="50%" height="100%" :size="1.7" :color="bombaGrasaManual == '1'
                ? 'yellow'
                : 'silver'"
                @click.native="escrituraAlternaIR(direccionVariablesBit.BOMBA_GRASA_MANUAL_ESCRITURA, bombaGrasaManual)">
              </HmiButton>
              <HmiButton class="grid-item" label="CICLO MANUAL ENGRASE" width="50%" height="100%" :size="1.7" :color="cicloManualEngrase == '1'
                ? 'yellow'
                : 'silver'"
                @touchstart.native.prevent="escrituraMomentaneaHR(direccionVariablesBit.CICLO_MANUAL_ENGRASE_ESCRITURA, '1')"
                @touchend.native.prevent="escrituraMomentaneaHR(direccionVariablesBit.CICLO_MANUAL_ENGRASE_ESCRITURA, '0')"
                @mousedown.native="escrituraMomentaneaHR(direccionVariablesBit.CICLO_MANUAL_ENGRASE_ESCRITURA, '1')"
                @mouseup.native="escrituraMomentaneaHR(direccionVariablesBit.CICLO_MANUAL_ENGRASE_ESCRITURA, '0')">
              </HmiButton>
            </div>
          </div>
          <div class="column">
            <div class="custom-row">
              <HmiLabel class="grid-item" label="IMPULSO ARRANQUE d/seg." width="50%" height="100%" :size="1.7"
                color="cyan"></HmiLabel>
              <HmiLabel class="grid-item" :label="formato2digitos(impulsoArranque)" width="50%" height="100%" :size="1.7"
                color="#56FF56" :editable="true"
                @input="escrituraDM($event, direccionVariables.IMPULSO_ARRANQUE_ESCRITURA, 1)"></HmiLabel>
            </div>
            <div class="custom-row">
              <HmiLabel class="grid-item" label="ESPERA ARRANQUE d/seg." width="50%" height="100%" :size="1.7"
                color="cyan"></HmiLabel>
              <HmiLabel class="grid-item" :label="formato3digitos(esperaArranque)" width="50%" height="100%" :size="1.7"
                color="#56FF56" :editable="true"
                @input="escrituraDM($event, direccionVariables.ESPERA_ARRANQUE_ESCRITURA, 1)"></HmiLabel>
            </div>
            <div class="custom-row">
              <HmiLabel class="grid-item" label="TIEMPO ACCION B.GRASA Seg." width="50%" height="100%" :size="1.7"
                color="cyan"></HmiLabel>
              <HmiLabel class="grid-item" :label="formato3digitos(tiempoAccionBombaGrasa)" width="50%" height="100%"
                :size="1.7" color="#56FF56" :editable="true"
                @input="escrituraDM($event, direccionVariables.TIEMPO_ACCION_BOMBA_GRASA_ESCRITURA, 1)"></HmiLabel>
            </div>
            <div class="custom-row">
              <HmiLabel class="grid-item" label="TIEMPO ESPERA B.GRASA Min." width="50%" height="100%" :size="1.7"
                color="cyan"></HmiLabel>
              <HmiLabel class="grid-item" :label="formato2digitos(tiempoEsperaBombaGrasa)" width="50%" height="100%"
                :size="1.7" color="#56FF56" :editable="true"
                @input="escrituraDM($event, direccionVariables.TIEMPO_ESPERA_BOMBA_GRASA_ESCRITURA, 1)"></HmiLabel>
            </div>
            <div class="button">
              <HmiButton label="SALIR" height="100%" width="50%" :size="1.7" color="silver"
                @click.native="navigateToMenu"></HmiButton>
            </div>
          </div>
        </div>
      </div>
    </HmiPantalla>
  </div>
</template>

<script>
import HmiLabel from "@/components/HMI/HmiLabel.vue";
import HmiButton from "@/components/HMI/HmiButton.vue";
import HmiPantalla from "@/components/HMI/HmiPantalla.vue";
export default {
  name: "MenuPantalla",
  computed: {
    // Obtenemos el numero de pantalla en la que estamos trabajandos
    numeroPantalla() {
      return this.$route.params.numeroPantalla;
    },

    direccionVariables() {
      if (this.numeroPantalla == 1) {
        return {
          IMPULSO_ABRIR_LECTURA: 17, // Correspondiente a Dm48
          IMPULSO_ABRIR_ESCRITURA: "Dm0048", // Correspondiente a Dm48
          IMPULSO_CERRAR_LECTURA: 18, // Correspondiente a Dm49
          IMPULSO_CERRAR_ESCRITURA: "Dm0049", // Correspondiente a Dm49
          ESPERA_REGULACION_LECTURA: 19, // Correspondiente a Dm50
          ESPERA_REGULACION_ESCRITURA: "Dm0050", // Correspondiente a Dm50
          IMPULSO_ARRANQUE_LECTURA: 20, // Correspondiente a Dm51
          IMPULSO_ARRANQUE_ESCRITURA: "Dm0051", // Correspondiente a Dm51
          ESPERA_ARRANQUE_LECTURA: 21, // Correspondiente a Dm52
          ESPERA_ARRANQUE_ESCRITURA: "Dm0052", // Correspondiente a Dm52
          TIEMPO_ACCION_BOMBA_GRASA_LECTURA: 28, // Correspondiente a Dm61
          TIEMPO_ACCION_BOMBA_GRASA_ESCRITURA: "Dm0061", // Correspondiente a Dm61
          TIEMPO_ESPERA_BOMBA_GRASA_LECTURA: 27, // Correspondiente a Dm60
          TIEMPO_ESPERA_BOMBA_GRASA_ESCRITURA: "Dm0060", // Correspondiente a Dm60
        };
      } else {
        return {
          IMPULSO_ABRIR_LECTURA: 22, // Correspondiente a Dm54
          IMPULSO_ABRIR_ESCRITURA: "Dm0054", // Correspondiente a Dm54
          IMPULSO_CERRAR_LECTURA: 23, // Correspondiente a Dm55
          IMPULSO_CERRAR_ESCRITURA: "Dm0055", // Correspondiente a Dm55
          ESPERA_REGULACION_LECTURA: 24, // Correspondiente a Dm56
          ESPERA_REGULACION_ESCRITURA: "Dm0056", // Correspondiente a Dm56
          IMPULSO_ARRANQUE_LECTURA: 25, // Correspondiente a Dm57
          IMPULSO_ARRANQUE_ESCRITURA: "Dm0057", // Correspondiente a Dm57
          ESPERA_ARRANQUE_LECTURA: 26, // Correspondiente a Dm58
          ESPERA_ARRANQUE_ESCRITURA: "Dm0058", // Correspondiente a Dm58
          TIEMPO_ACCION_BOMBA_GRASA_LECTURA: 30, // Correspondiente a Dm63
          TIEMPO_ACCION_BOMBA_GRASA_ESCRITURA: "Dm0063", // Correspondiente a Dm63
          TIEMPO_ESPERA_BOMBA_GRASA_LECTURA: 29, // Correspondiente a Dm62
          TIEMPO_ESPERA_BOMBA_GRASA_ESCRITURA: "Dm0062", // Correspondiente a Dm62
        };
      }
    },

    direccionVariablesBit() {
      if (this.numeroPantalla == 1) {
        return {
          BOMBA_GRASA_MANUAL_LECTURA: [140, 10], // Correspondiente a 28.07
          BOMBA_GRASA_MANUAL_ESCRITURA: ["Ir0028", 7], // Correspondiente a 28.07
          CICLO_MANUAL_ENGRASE_LECTURA: [140, 11], // Correspondiente a 28.08
          CICLO_MANUAL_ENGRASE_ESCRITURA: ["Ir0028", 8], // Correspondiente a 28.08
          OK_NIVEL_GRASA_LECTURA: [140, 12], // Correspondiente a 1.07
        };
      } else {
        return {
          BOMBA_GRASA_MANUAL_LECTURA: [141, 10], // Correspondiente a 29.07
          BOMBA_GRASA_MANUAL_ESCRITURA: ["Ir0029", 7], // Correspondiente a 29.07
          CICLO_MANUAL_ENGRASE_LECTURA: [141, 11], // Correspondiente a 29.08
          CICLO_MANUAL_ENGRASE_ESCRITURA: ["Ir0029", 8], // Correspondiente a 29.08
          OK_NIVEL_GRASA_LECTURA: [142, 12], // Correspondiente a 3.07
        };
      }
    },

    impulsoAbrir() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.IMPULSO_ABRIR_LECTURA
        ];
      }
      return "0000";
    },

    impulsoCerrar() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.IMPULSO_CERRAR_LECTURA
        ];
      }
      return "0000";
    },

    esperaRegulacion() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.ESPERA_REGULACION_LECTURA
        ];
      }
      return "0000";
    },

    impulsoArranque() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.IMPULSO_ARRANQUE_LECTURA
        ];
      }
      return "0000";
    },

    esperaArranque() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.ESPERA_ARRANQUE_LECTURA
        ];
      }
      return "0000";
    },

    tiempoAccionBombaGrasa() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TIEMPO_ACCION_BOMBA_GRASA_LECTURA
        ];
      }
      return "0000";
    },

    tiempoEsperaBombaGrasa() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TIEMPO_ESPERA_BOMBA_GRASA_LECTURA
        ];
      }
      return "0000";
    },

    bombaGrasaManual() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.BOMBA_GRASA_MANUAL_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.BOMBA_GRASA_MANUAL_LECTURA[1]
        );
      }
      return "0";
    },

    cicloManualEngrase() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.CICLO_MANUAL_ENGRASE_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.CICLO_MANUAL_ENGRASE_LECTURA[1]
        );
      }
      return "0";
    },
  },
  components: {
    HmiLabel,
    HmiButton,
    HmiPantalla,
  },
  mounted() {
    //Mandar a nodered entrada
    this.mandarEntrada();
    //Cuando se cierre la ventana enviar señal
    window.addEventListener("unload", this.mandarSalida);
  },
  destroyed() {
    //Mandar a nodered salida
    this.mandarSalida();
  },
  methods: {
    // Navegación a "Menu"
    navigateToMenu() {
      this.$router.push(`/pantalla/${this.numeroPantalla}`);
    },

    // Emitir evento salida
    mandarSalida() {
      this.$emit("mandar-pagina", "pagina/salida", "4", this.numeroPantalla);
    },

    // Emitir evento entrada
    mandarEntrada() {
      this.$emit("mandar-pagina", "pagina/entrada", "4", this.numeroPantalla);
    },

    formato2digitos(dato) {
      return dato.substring(2, 4);
    },

    formato3digitos(dato) {
      return dato.substring(1, 4);
    },

    escrituraDM(value, direccion, canales) {
      direccion = direccion.substring(2);
      const payload = {
        name: "escrituraDM",
        direccion: direccion,
        valor: value.padStart(4 * canales, "0"),
      };
      this.$emit("mandar-escritura",payload);
    },

    escrituraAlternaIR(direccionEscritura, valor) {
      // // Determinar la dirección y el número de bit desde direccionEscritura
      let direccion = direccionEscritura[0].substring(2);
      let bit = direccionEscritura[1];

      const nuevoValor = valor == "0" ? "1" : "0";

      // Construir el payload
      const payload = {
        name: "escrituraIR",
        direccion: direccion,
        valor: nuevoValor,
        bit: bit,
      };

      // Emitir el nuevo payload
      this.$emit("mandar-escritura", payload);
    },

    escrituraMomentaneaHR(direccionEscritura, valor) {
      // Determinar la dirección y el número de bit desde direccionEscritura
      let direccion = direccionEscritura[0].substring(2);
      let bit = direccionEscritura[1];

      // Construir el payload con el nuevo valor hexadecimal
      const payload = {
        name: "escrituraIR",
        direccion: direccion,
        valor: valor,
        bit: bit,
      };
      // Emitir el nuevo payload
      this.$emit("mandar-escritura", payload);
    },
    obtenerBit(dato, posicion) {
      let intValue = parseInt(dato, 16);

      let binaryString = intValue.toString(2).padStart(16, "0");

      let bit = binaryString.charAt(binaryString.length - 1 - posicion);
      return bit;
    },
  },
};
</script>

<style scoped>
.title {
  font-family: "Courier New", Courier, monospace !important;
  text-align: center;
  margin: 20px 20px 0px 20px;
}

.content {
  height: 100%;
}

.screen-title {
  display: flex;
  justify-content: center;
  height: 15%;
}

.grid {
  padding-top: clamp(1px, 2vw - 5px, 20px);
  height: 85%;
  display: flex;
  flex-direction: row;
  gap: clamp(1px, 5vw - 5px, 40px);
}

.custom-row {
  padding-top: clamp(1px, 2vw - 5px, 20px);
  height: 20%;
  display: flex;
  justify-content: space-between;
  gap: clamp(1px, 2vw - 5px, 20px);
}

.column {
  height: 100%;
  width: 50%;
}

.button {
  padding-top: 20px;
  padding-left: 20px;
  height: 20%;
  display: flex;
  justify-content: flex-end;
}
</style>
